/** In-app strings for `DepartmentPermitsPage` (not from CMS JSON). */
export function getPermitPageStrings(locale) {
    const es = locale === 'es';
    return {
        searchNoResults: es
            ? 'Ninguna agencia ni permiso cargado coincide con su búsqueda. Pruebe otras palabras o abra una agencia para cargar sus permisos y buscar de nuevo.'
            : 'No agencies or loaded permits match your search. Try different keywords, or open an agency to load its permits and search again.',
        noPermitsMatchSearch: es
            ? 'Ningún permiso de esta agencia coincide con su búsqueda.'
            : 'No permits in this agency match your search.',
        noPermitsListed: es ? 'No hay permisos listados para esta agencia.' : 'No permits listed for this agency.',
        viewDetails: es ? 'Ver detalles' : 'View Details',
        applyNow: es ? 'Solicitar ahora' : 'Apply Now',
        matchChip: (n) => es
            ? n === 1
                ? '1 coincidencia'
                : `${n} coincidencias`
            : n === 1
                ? '1 match'
                : `${n} matches`,
        permitChip: (n) => es ? (n === 1 ? '1 permiso' : `${n} permisos`) : n === 1 ? '1 permit' : `${n} permits`,
        permitsRange: (from, to, total) => es ? `Permisos ${from}–${to} de ${total}` : `Permits ${from}–${to} of ${total}`,
        loadDepartmentFailed: es ? 'No se pudo cargar el departamento' : 'Failed to load department',
        loadPermitsFailed: es ? 'No se pudieron cargar los permisos' : 'Failed to load permits',
    };
}
